import api from '../config/api';

const searchService = {
  search: (q, type) => api.get('/search', { params: { q, type } }),
};

export default searchService;
